import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export interface HeaderCopyBlockContent {
  description?: string;
  heading?: string;
  subheading?: string;
}

const selectContent = (state: ReduxApplicationState) => state.content;
const selectProductsPages = (state: ReduxApplicationState) => state.products.pages;

/**
 * Content for the category route's header copy block, sourced from the category
 * content entry. Intro copy is shown only when the first PLP page is present.
 * This is category-only; the shop route uses `selectTaxonomyHeaderContent`.
 */
export const selectHeaderCopyBlockContent = createSelector(
  [selectContent, selectProductsPages],
  (content, pages): HeaderCopyBlockContent => {
    const category = content.category;

    if (!category?.heading) {
      return {};
    }

    return {
      heading: category.heading,
      subheading: category.subheading,
      description: Object.keys(pages).includes('1') ? category.description : undefined,
    };
  },
);
